






















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ESignBaseDate',
  props: {
    value: {
      type: String,
      required: true
    }
  }
});
